<template>
  <v-alert v-if="!form.busy && errors.length"
           type="error"
           tile>
    <div v-if="isHTMLBodyError">
      <div class="font-weight-bold">
        The Email Message Body is invalid.
      </div>
      <div>
        Double-check that the <a href="https://shopify.github.io/liquid/basics/introduction/" target="_blank" class="white--text">liquid tags are correct</a>. Contact <a :href="supportEmail" target="_blank" class="white--text">support@mobilelocker.com</a> if you need help.<br/>
        If you can, please include a screenshot.
      </div>
      <div class="font-weight-bold">
        Error message:
      </div>
      <div v-if="form.errors.get('html_body')">
        {{ form.errors.get('html_body') }}
      </div>
      <div v-else-if="form.errors.get('body')">
        {{ form.errors.get('body') }}
      </div>
    </div>
    <template v-else>
      <div v-for="error in errors"
           :key="error">
        {{ error }}
      </div>
    </template>
  </v-alert>
</template>
<script>
export default {
  props: {
    form: {
      type: Object,
      required: true,
    },
    template: {
      type: Object,
      required: false,
    }
  },
  computed: {
    isHTMLBodyError() {
      return this.form.errors.has('html_body')
        || this.form.errors.has('body'); // MLD-7015
    },
    errorMessage() { // MLD-7015
      if (this.form.errors.has('body')) {
        return this.form.errors.get('body');
      } else if (this.form.errors.has('html_body')) {
        return this.form.errors.get('html_body');
      }
      return null;
    },
    errors() {
      return this.form.errors.flatten();
    },
    supportEmail() { // MLD-7015
      const encodedSubject = encodeURIComponent(this.supportSubject);
      const encodedBody = encodeURIComponent(this.supportBody);
      return `mailto:support@mobilelocker.com?subject=${encodedSubject}&body=${encodedBody}`;
    },
    supportBody() {
      if (this.template) {
        if (this.isHTMLBodyError) {
          return `Hello Support,\nI need help with the email template ${this.template.id}.\nError message:\n${this.errorMessage}\n\nThanks,\n`
        } else {
          return `Hello Support,\nI need help with the mail template ${this.template.id}.\n[DESCRIBE THE PROBLEM HERE]\n\nThanks,\n`
        }
      }
      if (this.isHTMLBodyError) {
        return `Hello Support,\nI need help with a new email template.\nError message:\n${this.errorMessage}\n\nThanks,\n`
      } else {
        return `Hello Support,\nI need help with a new email template.\n[DESCRIBE THE PROBLEM HERE]\n\nThanks,\n`
      }
    },
    supportSubject() {
      if (this.template) {
        if (this.isHTMLBodyError) {
          return `Need Help with Email Template ${this.template.id} - error: ${this.errorMessage}`;
        }
        return `Need Help with Email Template ${this.template.id}`;
      } else {
        return `Help with New Email Template`;
      }
    }
  }
}
</script>
